import { useRef, useState } from "react";

/**
 * Controls a Radix menu's open state so it opens on hover (with a short
 * intent delay to bridge the gap to the panel) while click and keyboard keep
 * working. Spread `hoverProps` onto both the Trigger and the Content, and pass
 * `open`/`setOpen` to the menu root. Use `modal={false}` on the root so hover
 * isn't broken by scroll-lock / pointer-blocking.
 */
export function useHoverOpen(closeDelay = 120) {
  const [open, setOpen] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const cancelClose = () => {
    if (timer.current) clearTimeout(timer.current);
  };
  const openNow = () => {
    cancelClose();
    setOpen(true);
  };
  const closeSoon = () => {
    cancelClose();
    timer.current = setTimeout(() => setOpen(false), closeDelay);
  };

  const hoverProps = { onMouseEnter: openNow, onMouseLeave: closeSoon };
  return { open, setOpen, hoverProps };
}
